import { render, staticRenderFns } from "./PendingUsersDataTable.vue?vue&type=template&id=5afacc5e&scoped=true"
import script from "./PendingUsersDataTable.vue?vue&type=script&lang=js"
export * from "./PendingUsersDataTable.vue?vue&type=script&lang=js"
import style0 from "./PendingUsersDataTable.vue?vue&type=style&index=0&id=5afacc5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afacc5e",
  null
  
)

export default component.exports